import { StudioLogger } from '@studio/logger/StudioLogger';
import {
  getCurrentBroadcast,
  showNotification,
  clearModal
} from '@shoflo/studio-redux/actions';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/Modal';

const logger = new StudioLogger('socket-dispatcher');

function showWebSocketReconnectionMessage(dispatch) {
  dispatch(clearModal(LOST_REALTIME_SOCKET_CONNECTION));
  dispatch(
    showNotification('Realtime connection restored', {
      type: 'success',
      timeout: 1000 * 3
    })
  );
}

function reconnectRealTimeMessage(dispatch, getState) {
  const {
    meeting: { attendeeResponse }
  } = getState();

  showWebSocketReconnectionMessage(dispatch);

  window.realtimeConnectionLostTimeout = null;
  dispatch(getCurrentBroadcast(true));

  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };

  logger.error('Realtime connection restored', payload);
}

function socketReconnected({ dispatch, getState }) {
  reconnectRealTimeMessage(dispatch, getState);
}

export default socketReconnected;
